import type { PropsWithChildren } from 'react';
import { useTransition, animated, config } from '@react-spring/web';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

interface FadeT {
  children: React.ReactNode;
  show?: boolean;
  delay?: number;
  immediate?: boolean;
}

interface DescriptionProps {
  shouldShow: boolean;
  textAlign?: 'left' | 'right' | 'center';
}

const Fade = ({
  show = false,
  delay = 0,
  immediate = false,
  children,
}: FadeT) => {
  const transition = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: config.slow,
    delay,
    immediate,
  });

  return (
    <>
      {transition((styles, show) =>
        show ? <animated.div style={styles}>{children}</animated.div> : null,
      )}
    </>
  );
};

export const Description = ({
  shouldShow,
  textAlign,
  children,
}: PropsWithChildren<DescriptionProps>) => {
  return (
    // This box is needed to set the zIndex, otherwise the text would be behind the visualization until the fade is complete
    <Box zIndex={2} width="50%" maxWidth="50%">
      <Fade show={shouldShow}>
        {/* Background to be able to be seen regardless of background image */}
        <Box bg="bg" p={3} borderRadius={2} position="absolute" maxWidth="100%">
          <Text fontSize="200" textAlign={textAlign}>
            {children}
          </Text>
        </Box>
      </Fade>
    </Box>
  );
};
